import { getRegionalProjectDataSaga } from './getRegionalProjectsData'
import { addSocioEcoDataSaga } from './addSocioEcoData'
import { getSocioEcoDataSaga } from './getSocioEcoData'
import { uploadSocioEcoFileSaga } from './uploadSocioEcoFile'
import { getSocioStatGeneralSaga } from './getStatGeneral'
import { getEducationalHealthSaga } from './getEducationalHealth'
import RegionalProjectSaga from './donneesRegionalProject'

const SocioEcoDataSagas = [
    getRegionalProjectDataSaga,
    getSocioEcoDataSaga,
    addSocioEcoDataSaga,
    uploadSocioEcoFileSaga,
    getSocioStatGeneralSaga,
    getEducationalHealthSaga,
    ...RegionalProjectSaga,
]

export default SocioEcoDataSagas
